export default {
  submit: '提交',
  save: '保存',
  'submit1.ok': '提交成功',
  'save1.ok': '保存成功',
  'rules.require': '不可为空',
};
